import { reactive, ref, computed } from 'vue';

import FormInputComponent from '@/components/_shared/_partials/form-input/form-input.vue';

export default {
  name: 'AuthRegisterComponent',
  components: { FormInputComponent },
  setup() {
    const state = reactive({
      firstname: ref(null),
      lastname: ref(null),
      email: ref(null),
      username: ref(null),
      password: ref(null),
      confirm: ref(null),
      error: ref(null),
      mismatch: ref(false),
      showPassword: ref(false),
      canSubmit: computed(() => {
        const { firstname, lastname, email, username, password, confirm } = state;
        if (firstname && lastname && email && username && password && confirm) {
          if (password === confirm) {
            state.mismatch = false;
            return true;
          } else {
            state.mismatch = true;
            return false;
          }
        }
        return false;
      }),
    });

    const update = async (data) => {
      const { key, value } = data;
      state[key] = value;
    };

    const togglePassword = async () => state.showPassword = !state.showPassword

    return { state, update, togglePassword };
  },
  methods: {
    register: async function () {
      const { firstname, lastname, email, username, password, confirm } = this.state;
      this.$emit('register', { firstname, lastname, email, username, password, confirm });
    },
    login: async function () {
      this.$emit('login', {});
    }
  }
};
